// Add this helper function after your imports
export const formatNumberWithSpaces = (num) => {
  // If the input isn't a valid number, return it as is.
  if (typeof num !== "number" || isNaN(num)) {
    return num
  }
  // 'fr-FR' is a locale that uses spaces for thousand separators, perfect for your use case.
  return num.toLocaleString("fr-FR")
}
